import { dataSourcesStardogRequestDispatchers } from 'src/actions/data-sources/actionCreators';
import {
  databasesActionCreators,
  databasesStardogRequestDispatchers,
} from 'src/actions/databases/actionCreators';
import { DatabasesActionType } from 'src/actions/databases/actionTypes';
import {
  PermissionAction,
  PermissionResourceType,
} from 'src/constants/permissions';
import { isStardogFeatureSupportedSelector } from 'src/selectors/isStardogFeatureSupported';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';
import { hasPermission } from 'src/utils/hasPermission';

export const refreshDatabases =
  () => async (dispatch: AppDispatch, getState: ReduxStateGetter) => {
    dispatch(databasesActionCreators.refreshDatabasesStarted());

    const state = getState();
    const {
      connections: { connection },
    } = state;
    const isDatabaseListInfoSupported = isStardogFeatureSupportedSelector(
      'isDatabaseListInfoSupported',
      connection
    )(state);

    const databasesResponse = isDatabaseListInfoSupported
      ? await databasesStardogRequestDispatchers.requestDatabasesInfo()
      : await databasesStardogRequestDispatchers.requestDatabases();

    const promises: Array<Promise<any>> = [];

    promises.push(dataSourcesStardogRequestDispatchers.requestVirtualGraphs());

    if (
      databasesResponse.type === DatabasesActionType.REQUEST_DATABASES_SUCCESS
    ) {
      const {
        databases: { databaseIds },
        connections: { permissions },
      } = getState();

      databaseIds.forEach((databaseId) => {
        if (
          permissions &&
          hasPermission(
            permissions,
            PermissionAction.READ,
            PermissionResourceType.METADATA,
            databaseId
          )
        ) {
          promises.push(
            databasesStardogRequestDispatchers.requestDatabaseDetails(
              databaseId
            )
          );
        }
      });
    }

    await Promise.all(promises);

    dispatch(databasesActionCreators.refreshDatabasesFinished());
  };
